<template>
  <div :id="componentId" class="sp2-module-5" :style="moduleStyle">
    <div class="sp2-module-5-content" :style="contentStyle">
      <div class="sp2-industry-grid">
        <div
          v-for="(item, index) in displayList"
          :key="index"
          class="sp2-industry-item"
          :style="{ background: getItemBackground(index) }"
        >
          <span class="sp2-industry-text">{{ item.name || item }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const GRADIENT_BACKGROUNDS = [
  'linear-gradient(90deg, #FEFEFF 0%, #F0E7FF 100%)',
  'linear-gradient(90deg, #FCFFFD 0%, #EEFFF6 100%)',
  'linear-gradient(90deg, #FEFFFF 0%, #D8F2FF 100%)',
  'linear-gradient(90deg, #FEFEFE 0%, #DDDFFF 100%)',
  'linear-gradient(90deg, #FEFEFE 0%, #FFE7E3 100%)'
];

export default {
  name: 'SpTwoModule5',
  props: {
    componentId: {
      type: String,
      default: 'sp_two_module_5'
    }
  },
  data() {
    return {
      backgroundColor: '#fff',
      backgroundImage: '',
      list: [
        { name: '知识产权' },
        { name: '医 疗' },
        { name: '品牌广告' },
        { name: '快 消' },
        { name: '科 技' },
        { name: '舆情公关' },
        { name: '品牌广告' },
        { name: '快 消' }
      ]
    };
  },
  computed: {
    displayList() {
      return (this.list || []).slice(0, 20);
    },
    moduleStyle() {
      return {
        backgroundColor: this.backgroundColor
      };
    },
    contentStyle() {
      return {
        backgroundImage: this.backgroundImage ? `url(${this.backgroundImage})` : 'none',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      };
    }
  },
  methods: {
    getItemBackground(index) {
      return GRADIENT_BACKGROUNDS[index % GRADIENT_BACKGROUNDS.length];
    }
  }
};
</script>

<style scoped>
.sp2-module-5 {
  position: relative;
  width: 100%;
  padding: 16px 0;
  box-sizing: border-box;
  overflow: hidden;
}

.sp2-module-5-content {
  width: calc(100% - 24px);
  margin: 0 auto;
  padding: 24px 12px;
  box-sizing: border-box;
  border-radius: 12px;
}

.sp2-industry-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  width: 100%;
}

.sp2-industry-item {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 72px;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #FFFFFF;
  box-sizing: border-box;
}

.sp2-industry-text {
  font-size: 16px;
  color: #333333;
  line-height: 1.4;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}
</style>
